import React from "react";
import { PATHS } from "../../config/permissionsPaths";
import useAuth from "../../hooks/useAuth";
import styled from "styled-components";
import { FaAngleDoubleLeft, FaAngleDoubleRight } from "react-icons/fa";

const ToggleButtonWrapper = styled.div`
  position: fixed;
  top: 50%;
  right: ${(props) => (props.$collapsed ? 0 : "400px")};
  transform: translateY(-50%); 
  background-color: ${(props) => props.theme.sidebarBackground};
  color: ${(props) => props.theme.sidebarText};
  border: 1px solid #ccc;
  border-left: none;
  border-radius: 8px 0 0 8px;
  cursor: pointer;
  padding: 6px 2px;
  // z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: -2px 2px 6px rgba(0,0,0,0.1);
`;

const SidebarToggle = ({ collapsed, setCollapsed }) => {
  const { hasPermission } = useAuth();
  return (
    <>
      {hasPermission(PATHS.PREGUNTAS) && (
        <ToggleButtonWrapper onClick={() => setCollapsed(!collapsed)} $collapsed={collapsed}>
          {collapsed ? <FaAngleDoubleLeft className="hover" size={20} /> : <FaAngleDoubleRight className="hover" size={20} />}
        </ToggleButtonWrapper>
      )}
    </>
  );
};

export default SidebarToggle;
